import { getContext, track } from '../core';

const PRICING_PATTERNS = ['/pricing', '/roi'];

function isExternalLink(anchor: HTMLAnchorElement): boolean {
  try {
    return anchor.hostname !== '' && anchor.hostname !== window.location.hostname;
  } catch {
    return false;
  }
}

function isPricingLink(href: string): boolean {
  const lower = href.toLowerCase();
  return PRICING_PATTERNS.some((pattern) => lower.includes(pattern));
}

export function initExternalLinkTracking(): void {
  document.addEventListener('click', (e) => {
    const anchor = (e.target as HTMLElement).closest('a');
    if (!anchor || !anchor.href) return;

    const ctx = getContext();

    if (isPricingLink(anchor.href)) {
      track('pricing_intent_click', {
        link_url: anchor.href,
        link_text: (anchor.textContent || '').trim(),
        page_name: ctx.page_title,
      });
    }

    if (isExternalLink(anchor)) {
      track('external_link_click', {
        link_url: anchor.href,
        link_text: (anchor.textContent || '').trim(),
        page_name: ctx.page_title,
      });
    }
  });
}
